export const getRandomString = (length = 7) => Math.random().toString(36).substring(length);

export const textWithClarification = (txt, cl) => `${txt} (${cl})`;
